import { SxProps, Theme } from "@mui/material/styles";

export function listRequestsWrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1, 
        width: "100%", 
        borderRadius: "20px", 
        my: "24px", 
        // height: "calc(100vh - (84px * 1) - 2px - 48px)", 
        // maxHeight: "calc(100vh - (84px * 1) - 2px - 48px)"
    };
}

export function titleWrapper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#ececec"
    };
}

export function contentWrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1,
        width: "100%",
        // maxWidth: 1200,
        display: "grid",
        gridGap: "10px",
        justifyContent: "center",
        alignContent: "center", 
        // height: "calc(100vh - (84px * 1) - 2px - 48px)",
        gridTemplateColumns: "repeat( auto-fill, minmax(150px, 400px) )"
    };
}

export function card(theme: Theme): SxProps<Theme> {
    return {
        textAlign:'center',
        mx: 'auto',
        minWidth: {xs: 200, sm: 275, md: 350},
        maxWidth: {xs: 250, sm: 300, md: 400},
        width: '100%'
    };
}

export function modal(theme: Theme): SxProps<Theme> {
    return {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    }
}

export function gridContainer(theme: Theme): SxProps<Theme> {
    return {
        marginTop: '0.25rem',
        marginLeft: 0,
        paddingRight: '0.25rem',
        paddingLeft: '0.25rem',
        marginBottom: '1.25rem'
    }
}

export function createButton(theme: Theme): SxProps<Theme> {
    return {
        marginBottom: '1rem',
        marginTop: '1rem'
    }
}

export function cardActions(theme: Theme): SxProps<Theme> {
    return {
        justifyContent: 'center'
    }
}

export function cancelButton(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: 'grey !important',
        '&:hover': {
            backgroundColor: 'darkslategrey !important',
        }
    }
}

export function editTextField(theme: Theme): SxProps<Theme> {
    return {
        width: '100%'
    }
}